import { useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import { hasPrivilege } from './permissionUtils';
import './Unauthorized.css';

const AuthorizedRoute = ({ section, permission, children }) => {
  const { userData } = useUser();
  const navigate = useNavigate();

  if (!userData) return <div className="loading-spinner"></div>;

  const isAllowed = hasPrivilege(userData, section, permission);

  return isAllowed ? (
    children
  ) : (
    <div className="unauth-container">
      <div className="unauth-card">
        <div className="unauth-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z"/>
          </svg>
        </div>
        <h1 className="unauth-title">Access Denied</h1>
        <p className="unauth-description">
          You don't have permission to access this page. If you believe this is an error,
          please contact your system administrator.
        </p>
        <button className="unauth-button" onClick={() => navigate('/')}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="unauth-button-icon">
            <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
          </svg>
          Return to Dashboard
        </button>
      </div>
    </div>
  );
};

export default AuthorizedRoute;